import React from 'react';

const SatTab = props => {
  const {
    disabled,
    activeTab,
    children,
    onChange,
    customStyleClass,
    useTabHeader = false,
    optionalRender = undefined,
    legend,
  } = props;

  const handleTab = value => {
    if (!disabled) onChange(value);
  };

  return (
    <React.Fragment>
      <div className={`${useTabHeader ? 'tab-header' : ''}`}>
        <ul className={customStyleClass}>
          {children.map(child => {
            const {
              props: { tab },
            } = child;
            return (
              <li
                data-tab={tab.value}
                className={$classNames(tab?.styleClass ?? '', {
                  active: !disabled && activeTab === tab.value,
                  disabled: disabled,
                })}
                onClick={() => handleTab(tab.value)}
                key={tab.value}
              >
                <span className="tab">{tab.label}</span>
              </li>
            );
          })}
        </ul>
        {legend && legend}
        {optionalRender && <div className="tab-right">{optionalRender()}</div>}
      </div>

      {children.map(child => {
        return {
          ...child,
          props: {
            ...child.props,
            active: child.props.tab.value === activeTab,
          },
        };
      })}
    </React.Fragment>
  );
};

const TabPane = ({ active, className, children }) => {
  return (
    <div
      className={`tab-con ${className ? className : ''} ${
        active ? 'active' : ''
      }`}
    >
      {children}
    </div>
  );
};

SatTab.TabPane = TabPane;

export default SatTab;
